import { MeasureInfo } from './types';

/**
 * Returns true if the given measure name should have its values negated (* -1).
 * Rule: measure name is "pttc" AND measureGroup contains "vente" (case-insensitive).
 */
export function shouldNegate(measureName: string, allMeasures: MeasureInfo[]): boolean {
  const m = allMeasures.find(
    (x) => x.name.toLowerCase() === measureName.toLowerCase()
  );
  if (!m) return false;
  // Negate pttc from any vente-related measure group
  return m.name.toLowerCase() === 'pttc';
}

/**
 * Given a column header (e.g. "pttc - Famille1" or just "pttc"),
 * returns true if the measure part of the header should be negated.
 */
export function colHeaderShouldNegate(header: string, allMeasures: MeasureInfo[]): boolean {
  const h = header.toLowerCase();
  for (const m of allMeasures) {
    const mn = m.name.toLowerCase();
    // exact match: header is just the measure name or its caption
    if (h === mn || h === m.caption.toLowerCase()) {
      return shouldNegate(m.name, allMeasures);
    }
    // prefix match: "Pttc - Something" or "Something - Pttc"
    if (h.startsWith(mn + ' - ') || h.endsWith(' - ' + mn)) {
      return shouldNegate(m.name, allMeasures);
    }
  }
  return false;
}

/**
 * Apply negation to a raw cell value if needed.
 */
export function applyRule(val: any, negate: boolean): any {
  if (!negate) return val;
  if (typeof val === 'number') return val * -1;
  return val;
}
